export default class CartoDbLayer {

    constructor(_userName, _name, _iMap, _options) {
        this.name = _name;
        this.iMap = _iMap;
        this.options = _options;
        this.userName = _userName;
        this.cartoLayer = undefined;
        this.cartoSubLayers = {};
        this.create();
    }

    create() {
        var self = this;
        window.cartodb.createLayer(self.iMap, {
            user_name: self.userName,
            type: "cartodb",
            sublayers: self.options.sublayers || [],
            interactivity: ((self.options.interactivity != undefined)? self.options.interactivity.join(",") : []),
            interaction: self.options.interaction || true
            }, {
                https: true,
                layerIndex: 1024
            })
            .addTo(self.iMap)
            .done(function (layer) {
                self.cartoLayer = layer;
                self.createSublayer();
            })
            .error(function (e) {
                console.log(e);
            });

    }

    createSublayer() {
        var subLayer = this.cartoSubLayers['default'] = this.cartoLayer.createSubLayer({
            sql: this.options.sql,
            cartocss: this.options.css,
            interactivity: this.options.interactivity
        });

        if (this.options.interaction) {
            subLayer.setInteraction(this.options.interaction);
        };

        if (this.options.events) {
            for (var k in this.options.events) {
                subLayer.on(k, this.options.events[k]);
            }
        };
    }

    on() {
        for (var i in this.cartoSubLayers) {
            this.cartoSubLayers[i].show();
        }
    }

    off() {
        for (var i in this.cartoSubLayers) {
            this.cartoSubLayers[i].hide();
        }
    }
}